import './main.css';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Flowbite } from 'flowbite-react';
import { createRoot } from 'react-dom/client';

import { ApiContext } from './api/api.context';
import { createApi } from './api/api.endpoints';
import { ApiClient } from './api/apiClient';
import { ToastNotificationProvider } from './app/components/toastNotification/toastNotifications.context';
import { MainView } from './app/views/main.view';
import { ModalsProvider } from './contexts/modals.context';
import { CustomTheme } from './theme';

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
});

const apiClient = new ApiClient({
    baseUrl: '/api'
});

const api = createApi(apiClient);
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: true,
            retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 5000),
        }
    }
});

// Render your React component instead
const root = createRoot(document.getElementById('app')!, {
    onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
    <ApiContext.Provider value={{ api }}>
        <QueryClientProvider client={queryClient}>
            <Flowbite theme={{ theme: CustomTheme, mode: 'light' }}>
                <ToastNotificationProvider>
                    <ModalsProvider>
                        <MainView />
                    </ModalsProvider>
                </ToastNotificationProvider>
            </Flowbite>
        </QueryClientProvider>
    </ApiContext.Provider>
);

document.getElementById('loading')?.classList.add('hidden');
